"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionCircleFilled = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var helios_styles_1 = require("@carvana/helios-styles");
var QuestionCircleFilled = function (_a) {
    var _b = _a.color, color = _b === void 0 ? helios_styles_1.icon.default : _b, _c = _a.size, size = _c === void 0 ? 24 : _c;
    return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { fill: color, fillRule: "evenodd", clipRule: "evenodd", d: "M12.5 1c-6.075 0-11 4.925-11 11s4.925 11 11 11 11-4.925 11-11-4.925-11-11-11Zm.258 7.024a2 2 0 0 0-2.225 1.307 1 1 0 1 1-1.886-.663A4 4 0 0 1 16.42 10c0 1.53-1.135 2.54-1.945 3.08a7.95 7.95 0 0 1-1.075.597V14a1 1 0 1 1-2 0v-1a1 1 0 0 1 .772-.974l.02-.008a6.051 6.051 0 0 0 1.172-.6c.69-.46 1.056-.95 1.056-1.418v-.002a2 2 0 0 0-1.662-1.974ZM11.5 17a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2h-.01a1 1 0 0 1-1-1Z" }) })));
};
exports.QuestionCircleFilled = QuestionCircleFilled;
